import { render, staticRenderFns } from "./FormbuilderUserSubmittedDataList.vue?vue&type=template&id=cddd9e04&scoped=true"
import script from "./FormbuilderUserSubmittedDataList.vue?vue&type=script&lang=js"
export * from "./FormbuilderUserSubmittedDataList.vue?vue&type=script&lang=js"
import style0 from "./FormbuilderUserSubmittedDataList.vue?vue&type=style&index=0&id=cddd9e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddd9e04",
  null
  
)

export default component.exports